import Joi from 'joi-browser';

export default {
  interests: Joi.array()
    .label('Intereses')
    .required()
    .min(1),
  subject: Joi.string()
    .label('Asunto')
    .required(),
  content: Joi.object()
    .required(),
};



// WEBPACK FOOTER //
// ./src/containers/Admin/MassiveMailer/validation.js